import React, { FC } from 'react';
import { TypeVideoEmbedSectionFields } from '@/core/generated-types';
import { VideoEmbed } from '@/components/common/VideoEmbed/VideoEmbed';
import classNames from 'classnames';
import { UniversalCta } from '../UniversalCta';
import { RichTextHeading } from '../RichTextHeading';
import { Document } from '@contentful/rich-text-types';

const backgroundClass = (showPaintStrokes: boolean) => {
  return showPaintStrokes
    ? `before:absolute before:left-0 before:top-[-50px] before:block before:h-[50px] before:w-[50px] before:bg-videoBackgroundLeft before:bg-no-repeat before:content-[''] after:absolute after:bottom-[-43px] after:right-0 after:block after:h-[44px] after:w-[112px] after:bg-videoBackgroundRight after:bg-no-repeat after:content-[''] md:before:left-[-61px] md:before:top-[-32px] md:before:h-[244px] md:before:w-[129px] md:before:bg-videoBackgroundLeftMd md:after:bottom-[-10px] md:after:right-[-12px] md:after:h-[134px] md:after:w-[190px] md:after:bg-videoBackgroundRightMd`
    : '';
};

export const VideoEmbedSection: FC<TypeVideoEmbedSectionFields> = ({
  entryName,
  heading = '',
  videoEmbed,
  showPaintStrokes,
  cta,
  anchorId,
  richTextHeading,
  introText,
}) => {
  return (
    <div
      className="overflow-hidden py-10 lg:py-20"
      data-testid={`video-embed-${entryName}`}
      id={anchorId}
    >
      {heading && (
        <h4 className="title-container container m-auto mb-5 text-center text-d-h3 font-bold md:text-d-h2 lg:mb-10">
          {heading}
        </h4>
      )}
      {richTextHeading && (
        <RichTextHeading
          content={richTextHeading as Document}
          classNames="title-container container m-auto mb-5 text-center lg:mb-10"
        />
      )}
      {introText && (
        <div className="container mx-auto text-center my-4 lg:-mt-6 lg:mb-8">
          {introText}
        </div>
      )}
      <div
        id="video-embed-section"
        className={classNames(
          'relative mx-auto max-w-[990px] text-center md:px-10',
          backgroundClass(showPaintStrokes),
        )}
      >
        <div className="mx-auto max-h-[556px] max-w-[990px] overflow-hidden">
          <div className="aspect-h-9 aspect-w-16 relative z-10 mx-auto">
            <VideoEmbed
              classes="mx-auto max-h-[556px] w-full"
              {...videoEmbed.fields}
            />
          </div>
        </div>
      </div>
      {cta && (
        <div className="z-10 mt-10 inline-flex w-full justify-center px-6 text-center">
          <UniversalCta link={cta} />
        </div>
      )}
    </div>
  );
};
